module.exports = __webpack_public_path__ + "img/search_active.7c71b39f.svg";